import React from 'react';
import { Box } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { ETransactionStatus } from 'common/transactions.interface';

type Props = {
  status: ETransactionStatus;
};

type PaymentStatus = 'PENDENTE' | 'APROVADO' | 'RECUSADO' | 'PROCESSANDO' | 'EXPIRADO';

const getPaymentStatus = (status: ETransactionStatus): PaymentStatus => {
  if (status === ETransactionStatus.PENDING_APPROVAL) {
    return 'PENDENTE';
  }

  if (status === ETransactionStatus.SENT_TO_PROVIDER || status === ETransactionStatus.PROCESSING) {
    return 'PROCESSANDO';
  }

  if (status === ETransactionStatus.REJECTED_APPROVAL) {
    return 'RECUSADO';
  }

  if (status === ETransactionStatus.ERROR) {
    return 'RECUSADO';
  }

  if (status === ETransactionStatus.EXPIRED) {
    return 'EXPIRADO';
  }

  return 'APROVADO';
};

const statusConfig: Record<PaymentStatus, { color: string; background: string; icon: React.ElementType; label: string }> = {
  PENDENTE: {
    color: '#E26A00',
    background: '#FFF3E6',
    icon: WarningAmberIcon,
    label: 'Pendente',
  },
  PROCESSANDO: {
    color: '#8A8A8A',
    background: '#F4F4F4',
    icon: HourglassEmptyIcon,
    label: 'Processando',
  },
  RECUSADO: {
    color: '#D32F2F',
    background: '#FDECEC',
    icon: CloseIcon,
    label: 'Recusado',
  },
  APROVADO: {
    color: '#0A7A3D',
    background: '#ECFDF3',
    icon: CheckIcon,
    label: 'Aprovado',
  },
  EXPIRADO: {
    color: '#616161',
    background: '#F5F5F5',
    icon: AccessTimeIcon,
    label: 'Expirado',
  },
};

const PaymentStatusPill = ({ status }: Props) => {
  const paymentStatus = getPaymentStatus(status);
  const { color, background, icon: Icon, label } = statusConfig[paymentStatus];

  return (
    <Box
      sx={{
        px: 1.5,
        py: 0.4,
        borderRadius: '999px',
        backgroundColor: background,
        color,
        fontSize: 12,
        fontWeight: 500,
        width: 'fit-content',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Icon sx={{ fontSize: 15, marginRight: '3px' }} />
      {label}
    </Box>
  );
};

export default PaymentStatusPill;
